var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
let Cta = class Cta extends Vue {
};
__decorate([
    Prop()
], Cta.prototype, "url", void 0);
__decorate([
    Prop()
], Cta.prototype, "target", void 0);
__decorate([
    Prop()
], Cta.prototype, "sizes", void 0);
__decorate([
    Prop()
], Cta.prototype, "currentPage", void 0);
__decorate([
    Prop()
], Cta.prototype, "activeSectorId", void 0);
__decorate([
    Prop()
], Cta.prototype, "ariaLabel", void 0);
__decorate([
    Prop()
], Cta.prototype, "color", void 0);
Cta = __decorate([
    Component
], Cta);
export default Cta;
